import { useMemo } from "react";
import { ALL_BATCHES } from "../../../../../entities/entities";
import {
  applyBatchAtLevel,
  getBatchLevelConfig,
} from "../../../../../utils/batchLevels";
import { useAnalysisAgentContext } from "../../_analysisAgentContext";
import DataFromAnotherBatch from "../widgets/DataFromAnotherBatch";
import type { ExpandedChildTablesType } from "./types/ExpandedChildTablesType";

const ExpandedChildTables: React.FC<ExpandedChildTablesType> = ({
  parentHash,
  parentFrequency,
  fetchAttributeStatistics,
  isLoadingAttrStatChildSubmit,
  isLoadingAttrStatChildValidation,
  disabled,
}) => {
  const {
    deferredActionsData,
    setDeferredActionsData,
    selectedBatches,
    setSelectedBatches,
    attributeToAnalyze,
    setParentRowExamplesParams,
    parentRowExamplesParams,
    parentRowSourceValuesParams,
    setParentRowSourceValuesParams,
    setActiveBatch,
  } = useAnalysisAgentContext();

  const level1 = useMemo(
    () => getBatchLevelConfig(ALL_BATCHES, selectedBatches, 1),
    [selectedBatches],
  );
  const level2 = useMemo(
    () => getBatchLevelConfig(ALL_BATCHES, selectedBatches, 2),
    [selectedBatches],
  );

  const setBatchForLevel = (level: number, batch: string) => {
    setSelectedBatches((prev) => applyBatchAtLevel(prev, level, batch));
  };

  const sharedProps = {
    attrToAnalyze: attributeToAnalyze,
    checkboxesLockRootParentHash: parentHash,
    deferredActionsData,
    setDeferredActionsData,
    setParentRowExamplesParams,
    parentRowExamplesParams,
    setParentRowSourceValuesParams,
    parentRowSourceValuesParams,
    setActiveBatch,
    fetchAttributeStatistics,
    isLoadingAttrStatChildSubmit,
    isLoadingAttrStatChildValidation,
    disabled,
  };

  return (
    <DataFromAnotherBatch
      key={`parent-${parentHash}`}
      {...sharedProps}
      parentRowStatChildHash={parentHash}
      parentRowOverlay={deferredActionsData.some(
        (item) => item.hash === parentHash,
      )}
      curBatch={selectedBatches[1] ?? ""}
      setBatch={(batch) => setBatchForLevel(1, batch)}
      availableBatches={level1.availableListDropdown}
      isFinalLevel={level1.isFinal}
      parentFrequency={parentFrequency}
      renderExpanded={
        level1.canExpand
          ? (record) => (
              <DataFromAnotherBatch
                key={`child-${record.hash}`}
                {...sharedProps}
                parentRowStatChildHash={record.hash}
                parentRowOverlay={
                  deferredActionsData.some(
                    (item) => item.hash === record.hash,
                  ) ||
                  deferredActionsData.some((item) => item.hash === parentHash)
                }
                curBatch={selectedBatches[2] ?? ""}
                setBatch={(batch) => setBatchForLevel(2, batch)}
                availableBatches={level2.availableListDropdown}
                isFinalLevel={level2.isFinal}
                parentFrequency={record.frequency}
              />
            )
          : undefined
      }
    />
  );
};
export default ExpandedChildTables;
